/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */

import React, { useState } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import ShortTextIcon from '@mui/icons-material/ShortText';
import SubjectIcon from '@mui/icons-material/Subject';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import {
  ClickAwayListener, Fade, IconButton, Paper, Popper,
} from '@mui/material';
import axios from 'axios';
import { useMutation } from 'react-query';
import { useSnackbar } from 'notistack';
import StradaLoader from 'shared-components/components/StradaLoader';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';

import type { ICreateDialog, ICeleryProgressResponse } from './types';
import './_autoRep.scss';

function AIIcon(): JSX.Element {
  return (
    <svg width='20' height='20' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.0117 6.75C15.4102 6.75 15.7734 6.85547 16.1016 7.06641C16.4531 7.25391 16.7344 7.52344 16.9453 7.875C17.1562 8.20312 17.2617 8.57812 17.2617 9C17.2617 9.42188 17.1562 9.80859 16.9453 10.1602C16.7344 10.4883 16.4531 10.7578 16.1016 10.9688C15.7734 11.1562 15.4102 11.25 15.0117 11.25V14.2383C15.0117 14.6602 14.8594 15.0234 14.5547 15.3281C14.2734 15.6094 13.9219 15.75 13.5 15.75H4.5C4.07812 15.75 3.71484 15.6094 3.41016 15.3281C3.12891 15.0234 2.98828 14.6602 2.98828 14.2383V11.25C2.58984 11.25 2.21484 11.1562 1.86328 10.9688C1.53516 10.7578 1.26562 10.4883 1.05469 10.1602C0.84375 9.80859 0.738281 9.42188 0.738281 9C0.738281 8.57812 0.84375 8.20312 1.05469 7.875C1.26562 7.52344 1.53516 7.25391 1.86328 7.06641C2.21484 6.85547 2.58984 6.75 2.98828 6.75V5.23828C2.98828 4.83984 3.12891 4.5 3.41016 4.21875C3.71484 3.91406 4.07812 3.76172 4.5 3.76172H6.75C6.75 3.33984 6.84375 2.96484 7.03125 2.63672C7.24219 2.28516 7.51172 2.01562 7.83984 1.82812C8.19141 1.61719 8.57812 1.51172 9 1.51172C9.42188 1.51172 9.79688 1.61719 10.125 1.82812C10.4766 2.01562 10.7461 2.28516 10.9336 2.63672C11.1445 2.96484 11.25 3.33984 11.25 3.76172H13.5C13.9219 3.76172 14.2734 3.91406 14.5547 4.21875C14.8594 4.5 15.0117 4.83984 15.0117 5.23828V6.75ZM5.625 8.61328C5.625 8.94141 5.73047 9.21094 5.94141 9.42188C6.17578 9.63281 6.44531 9.73828 6.75 9.73828C7.05469 9.73828 7.3125 9.63281 7.52344 9.42188C7.75781 9.21094 7.875 8.94141 7.875 8.61328C7.875 8.30859 7.75781 8.05078 7.52344 7.83984C7.3125 7.60547 7.05469 7.48828 6.75 7.48828C6.44531 7.48828 6.17578 7.60547 5.94141 7.83984C5.73047 8.05078 5.625 8.30859 5.625 8.61328ZM11.9883 12.7617V11.25H6.01172V12.7617H11.9883ZM11.25 9.73828C11.5547 9.73828 11.8125 9.63281 12.0234 9.42188C12.2578 9.21094 12.375 8.94141 12.375 8.61328C12.375 8.30859 12.2578 8.05078 12.0234 7.83984C11.8125 7.60547 11.5547 7.48828 11.25 7.48828C10.9453 7.48828 10.6758 7.60547 10.4414 7.83984C10.2305 8.05078 10.125 8.30859 10.125 8.61328C10.125 8.94141 10.2305 9.21094 10.4414 9.42188C10.6758 9.63281 10.9453 9.73828 11.25 9.73828Z' fill='#212121' fillOpacity='0.87' />
    </svg>
  );
}

function CreateDialog(props: ICreateDialog): JSX.Element {
  const {
    selectedMsgInfo,
    setEditMsg,
    setMessage,

  } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [tempDesc, setTempDesc] = useState<string>('');
  const [loader, setLoader] = useState<boolean>(false);
  const { mutate: getCeleryProgress } = useMutation(async (taskID: string) => axios({
    url: `api/chat-gpt/task_progress/?task_id=${taskID}`,
    method: 'get',
  }), {
    onSuccess: (res: ICeleryProgressResponse, taskID) => {
      if (res.data.detail.progress.percent !== 100 || res.data.detail.result === undefined) {
        setTimeout((): void => {
          getCeleryProgress(taskID);
        }, 1000);
      } else if (res.data.detail.result.message !== undefined) {
        setEditMsg(res.data.detail.result.message);
        setMessage(res.data.detail.result.message);
        setTempDesc('');
        setLoader(false);
      } else {
        enqueueSnackbar('Something went wrong!');
      }
    },
    onError: (err: { data: { detail: { result: { message: string } } } }) => {
      enqueueSnackbar(err.data.detail.result.message, {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
    },
  });

  const { mutate: onMessageGenerate } = useMutation(async (instructions: string) => axios({
    url: 'api/chat-gpt/generate-email-reminder/',
    method: 'post',
    data: {
      reminder_id: selectedMsgInfo?.reminder_id,
      reminder_of: selectedMsgInfo?.reminder_of,
      description: tempDesc,
      reminder_instruction: instructions,
    },
  }), {
    onSuccess: (res: { data: { detail: { task_id: string } } }) => {
      if (res.data) {
        getCeleryProgress(res.data.detail.task_id);
        setLoader(true);
      }
    },
    onError: () => {
      enqueueSnackbar('Error in Creating Checklist', {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
    },
  });

  return (
    <div>

      <StradaLoader open={loader} message='Generating...' />
      <PopupState variant='popper' popupId='demo-popup-popper'>
        {(popupState): JSX.Element => (
          <div aria-hidden='true' onClick={(): void => { }}>
            <IconButton className='merge-tag-div' {...bindToggle(popupState)}>
              <AIIcon />
            </IconButton>
            <Popper
              {...bindPopper(popupState)}
              transition
              placement='right-start'
            >
              {({ TransitionProps }): JSX.Element => (
                <ClickAwayListener onClickAway={(): void => { popupState.close(); }}>
                  <Fade {...TransitionProps} timeout={350}>
                    <Paper className='ai-popover' elevation={4}>
                      <div
                        className='chart-btn'
                        style={{ borderBottom: '1px solid #E4E4E4' }}
                        onClick={(): void => {
                          popupState.close();
                          onMessageGenerate('formal');
                        }}
                        aria-hidden='true'
                      >
                        <RefreshIcon />
                        <span className='ms-3'>Generate</span>
                      </div>
                      <h6>LENGTH</h6>
                      <div
                        className='chart-btn'
                        onClick={(): void => {
                          popupState.close();
                          onMessageGenerate('make shorter');
                        }}
                        aria-hidden='true'
                      >
                        <ShortTextIcon />
                        <span className='ms-3'>Make shorter</span>
                      </div>
                      <div
                        className='chart-btn'
                        onClick={(): void => {
                          popupState.close();
                          onMessageGenerate('make longer');
                        }}
                        style={{ borderBottom: '1px solid #E4E4E4' }}
                        aria-hidden='true'
                      >
                        <SubjectIcon />
                        <span className='ms-3'>Make longer</span>
                      </div>
                      <h6>TONE</h6>
                      <div
                        className='chart-btn'
                        onClick={(): void => {
                          popupState.close();
                          onMessageGenerate('more formal');
                        }}
                        aria-hidden='true'
                      >
                        <ChatBubbleIcon />
                        <span className='ms-3'>More formal</span>
                      </div>
                      <div
                        className='chart-btn'
                        onClick={(): void => {
                          popupState.close();
                          onMessageGenerate('more casual');
                        }}
                        aria-hidden='true'
                      >
                        <ChatBubbleIcon />
                        <span className='ms-3'>More casual</span>
                      </div>
                      <div
                        className='chart-btn'
                        onClick={(): void => {
                          popupState.close();
                          onMessageGenerate('more friendly');
                        }}
                        style={{ borderBottom: '1px solid #E4E4E4' }}
                        aria-hidden='true'
                      >
                        <ChatBubbleIcon />
                        <span className='ms-3'>More friendly</span>
                      </div>
                    </Paper>
                  </Fade>
                </ClickAwayListener>
              )}
            </Popper>
          </div>
        )}
      </PopupState>

    </div>

  );
}

export default CreateDialog;
